import React from 'react';
import { Reveal } from './Reveal';
type IconComponent = React.ComponentType<{
  className?: string;
  'aria-hidden'?: boolean;
}>;
interface SectionHeadingProps {
  badge?: string;
  badgeIcon?: IconComponent;
  title: React.ReactNode;
  subtitle?: React.ReactNode;
  id?: string;
  align?: 'center' | 'left';
}

/** Orange accent used inside section titles. */
export function Accent({
  children
}: {
  children: React.ReactNode;
}) {
  return <span className="text-ember-400" data-id="element-160" data-mp="bl5akmrt385w">{children}</span>;
}
export function SectionHeading({
  badge,
  badgeIcon: BadgeIcon,
  title,
  subtitle,
  id,
  align = 'center'
}: SectionHeadingProps) {
  const isCenter = align === 'center';
  return <Reveal className={`flex max-w-3xl flex-col ${isCenter ? 'mx-auto items-center text-center' : 'items-start text-left'}`} data-id="element-161" data-mp="6tdig7t04udn">
      {badge ? <span className="inline-flex items-center gap-2 rounded-sm border border-circuit-400/25 bg-circuit-400/[0.07] px-3 py-1.5 text-[0.7rem] font-semibold uppercase tracking-[0.18em] text-circuit-300" data-id="element-162" data-mp="uifxr905yb4z">
          {BadgeIcon ? <BadgeIcon className="h-3.5 w-3.5 text-ember-400" aria-hidden={true} data-id="element-163" data-mp="1ta8pbi2b2lp8" /> : null}
          {badge}
        </span> : null}
      <h2 id={id} className={`${badge ? 'mt-4' : ''} font-display text-3xl font-bold uppercase leading-[1.05] tracking-tight text-ink-50 sm:text-4xl lg:text-5xl`} data-id="element-164" data-mp="1o91k9qrjs0m9">
        {title}
      </h2>
      {subtitle ? <p className="mt-4 text-base leading-relaxed text-ink-400 sm:text-lg" data-id="element-165" data-mp="2c0gojp2vws05">{subtitle}</p> : null}
    </Reveal>;
}